export default __webpack_public_path__ + "images/6H.b302037.png";